<template>
  <div class="layout">
    <Layout>
      <Sider
        ref="side1"
        hide-trigger
        collapsible
        :collapsed-width="78"
        v-model="isCollapsed"
        :style="{ background: '#fff' }"
      >
        <div :class="logoClasses">
          <div class="layout-logo">{{ logoContent }}</div>
        </div>
        <Menu
          active-name="1-1"
          theme="light"
          width="auto"
          :open-names="[0]"
          :class="menuitemClasses"
          @on-select="toMenu"
          :style="{ height: 'calc(100vh - 66px)', overflowY: 'auto' }"
        >
          <Submenu
            v-for="(item, index) in rootList"
            :key="index"
            :name="item.name"
          >
            <template #title>
              <Icon :type="item.menuIcon"></Icon>
              <span>{{ item.title }}</span>
            </template>
            <MenuItem
              v-for="(subItem, subIndex) in item.children"
              :key="subIndex"
              :name="subItem.name"
              ><span>{{ subItem.title }}</span></MenuItem
            >
          </Submenu>
        </Menu>
      </Sider>
      <Layout>
        <Header :style="{ padding: 0, background: '#fff' }">
          <Icon
            @click="collapsedSider"
            :class="rotateIcon"
            :style="{ margin: '0 20px' }"
            type="md-menu"
            size="24"
          ></Icon>
          <div style="float: right; padding-right: 30px; display: flex">
            <div style="width: 56px">
              <Notification
                auto-count
                @on-load-more="handleLoadMore"
                @on-clear="handleClear"
                :style="{ lineHeight: '32px', margin: '20px auto' }"
              >
                <template #icon>
                  <Icon type="ios-notifications-outline" size="32" />
                </template>
                <NotificationTab
                  title="通知"
                  name="message"
                  :count="total"
                  :loading="messageLoading"
                  :loaded-all="isLoadedAll"
                >
                  <NotificationItem
                    v-for="(item, index) in messageList"
                    :key="index"
                    :title="item.title"
                    :icon="item.icon"
                    :icon-color="item.iconColor"
                    :time="item.time"
                    :read="item.status"
                    :tag="item.tag"
                    :tagProps="item.tagProps"
                    @on-item-click="checkRead(item, $event)"
                  />
                  <template #load-more> 点击加载更多 </template>
                  <template #clear>
                    <span>清空全部</span>
                  </template>
                </NotificationTab>
              </Notification>
            </div>
            <div>
              <Dropdown>
                <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" />
                <template #list>
                  <DropdownMenu>
                    <DropdownItem @click="logout()">退出登录</DropdownItem>
                  </DropdownMenu>
                </template>
              </Dropdown>
            </div>
          </div>
        </Header>
        <div class="tag-view">
          <Tag
            v-for="item in tagList"
            :key="item"
            :name="item.name"
            :checked="item.checked"
            :closable="item.closable"
            type="dot"
            size="medium"
            :color="item.color"
            @on-close="closeTag"
            @click="toTag(item.name)"
            :style="{ cursor: 'pointer' }"
            >{{ item.title }}</Tag
          >
        </div>
        <Content
          :style="{
            margin: '0px 10px 20px 10px',
            background: '#fff',
            minHeight: '260px',
          }"
        >
          <!--vue3-->
          <router-view v-slot="{ Component, route }">
            <transition name="fade" mode="out-in">
              <keep-alive :include="include">
                <component :is="Component" />
              </keep-alive>
              <!-- <component :is="Component" v-else /> -->
            </transition>
          </router-view>
          <!--vue2-->
          <!-- <keep-alive :include="include">
              <transition name="fade" mode="out-in">
                <router-view v-if="$route.meta.noCache">
                </router-view>
              </transition>
            </keep-alive>
            <router-view v-if="!$route.meta.noCache">
            </router-view> -->
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import util from "@/utils/util";
export default {
  name: "homeFrame",
  data() {
    return {
      isCollapsed: false,
      logoContent: "新世纪食品展",
      menuList: [],
      rootList: [],
      messageList: [],
      total: 0,
      messageLoading: false,
      isLoadedAll: false,
      queryPage: {
        current: 1,
        size: 5,
      },
      tagList: [],
      include: [],
    };
  },
  created() {
    util.postData("system/getUserMenu", {}).then((res) => {
      if (res.data.code !== 0) {
        // 报错
        this.$Message.error(res.data.msg);
        return;
      }
      this.menuList = res.data.menuList;
      let menus = new Array();
      this.menuList.forEach((item, index) => {
        if (item.parentId == "0") {
          let children = new Array();
          this.menuList.forEach((subItem, subIndex) => {
            if (subItem.parentId == item.menuId) {
              subItem.name = index + "-" + subIndex;
              subItem.color = "primary";
              children.push(subItem);
            }
          });
          item.name = index + "";
          item.children = children;
          menus.push(item);
        }
      });
      this.rootList = menus;
    });
    this.getNotice();
    this.initFirst();
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    logoClasses() {
      return [
        "class",
        this.isCollapsed ? "sidebar-logo-s" : "sidebar-logo-container",
      ];
    },
  },
  watch: {
    $route(to, from) {
      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.noCache) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
    },
  },
  methods: {
    collapsedSider() {
      this.isCollapsed
        ? (this.logoContent = "新世纪食品展")
        : (this.logoContent = "");
      this.$refs.side1.toggleCollapse();
    },
    logout() {
      localStorage.clear();
      this.$router.push({ path: "/" });
    },
    getNotice() {
      this.messageLoading = true;
      util.postData("system/getNotice", this.queryPage).then((res) => {
        this.messageLoading = false;
        if (res.data.code !== 0) {
          // 报错
          this.$Message.error(res.data.msg);
          return;
        }
        this.total = parseInt(res.data.pages.total);
        let list = res.data.pages.records;
        list.forEach((item, index) => {
          item.tag = item.status == "0" ? "未读" : "已读";
          item.tagProps =
            item.status == "0" ? { color: "red" } : { color: "blue" };
        });
        this.messageList = this.messageList.concat(list);
        if (this.messageList.length == this.total) {
          this.isLoadedAll = true;
        }
      });
    },
    handleLoadMore(tab) {
      this.loadMore(tab.name);
    },
    loadMore(type) {
      this.queryPage.current++;
      this.getNotice();
    },
    handleClear(tab) {
      this.clearUnread(tab.name);
    },
    clearUnread(type) {
      util.postData("system/noticeReadAll", {}).then((res) => {
        if (res.data.code !== 0) {
          // 报错
          this.$Message.error(res.data.msg);
          return;
        }
        this.messageList = [];
        this.isLoadedAll = true;
        this.total = 0;
      });
    },
    checkRead(row, item) {
      if (row.status == "1") {
        return;
      }
      util
        .postData("system/noticeRead", {
          id: row.id,
        })
        .then((res) => {
          if (res.data.code !== 0) {
            // 报错
            this.$Message.error(res.data.msg);
            return;
          }
          row.status = "1";
          row.tag = "已读";
          row.tagProps = { color: "blue" };
          this.total--;
        });
    },
    toMenu(name) {
      let menuUrl;
      let tab = this.getTab(name);
      if (tab == null) {
        let menu = this.getMenuItem(name);
        menu.checked = true;
        menu.closable = true;
        menu.color = "success";
        menuUrl = menu.menuUrl;
        this.tagList.push(menu);
      } else {
        menuUrl = tab.menuUrl;
      }
      this.$router.push({ path: menuUrl });
    },
    getTab(name) {
      let tab;
      for (var i = 0; i < this.tagList.length; i++) {
        this.tagList[i].checked = false;
        this.tagList[i].color = "primary";
        if (this.tagList[i].name == name) {
          tab = this.tagList[i];
          tab.color = "success";
          tab.checked = true;
        }
      }
      return tab;
    },
    getMenuItem(name) {
      for (var i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].name == name) return this.menuList[i];
      }
    },
    closeTag(event, name) {
      if (name == -1) {
        return;
      }
      let isNow = false;
      for (var i = 0; i < this.tagList.length; i++) {
        if (this.tagList[i].name == name) {
          if (this.tagList[i].checked) {
            isNow = true;
          }
          this.tagList.splice(i, 1);
        }
      }
      if (isNow) {
        let menu = this.tagList[this.tagList.length - 1];
        menu.checked = true;
        menu.color = "success";
        this.$router.push({ path: menu.menuUrl });
      }
    },
    initFirst() {
      this.tagList.push({
        checked: true,
        menuId: -1,
        menuUrl: "/",
        name: -1,
        parentId: "1",
        title: "首页",
        color: "success",
      });
    },
    toTag(name) {
      let checkMenu;
      for (var i = 0; i < this.tagList.length; i++) {
        this.tagList[i].checked = false;
        this.tagList[i].color = "primary";
        if (this.tagList[i].name == name) {
          checkMenu = this.tagList[i];
        }
      }
      checkMenu.checked = true;
      checkMenu.color = "success";
      this.$router.push({ path: checkMenu.menuUrl });
    },
  },
  mounted() {},
  components: {},
};
</script>

<style scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 90px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
/* 
.fixed-header+.app-main {
  padding-top: 50px;
} */

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo {
  width: 150px;
  height: 30px;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 25px;
  color: white;
  line-height: 30px;
}
.layout .ivu-menu {
  z-index: 0;
}
.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 90px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
.sidebar-logo-container {
  position: relative;
  width: 200px;
  height: 64px;
  line-height: 64px;
  background-color: #2d8cf0;
  text-align: center;
  overflow: hidden;
  z-index: 999;
  display: flex;
}
.sidebar-logo-s {
  position: relative;
  width: 78px;
  height: 64px;
  line-height: 64px;
  background-color: #2d8cf0;
  text-align: center;
  overflow: hidden;
  z-index: 999;
  display: flex;
}
/**滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #999;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}

.tag-view {
  width: 100%;
  height: 45px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 5px 10px;
}
</style>
